import { config } from "../../../api/config";
import { CoordinateType, EnvMark } from "./lucky-draw/common/global-variable";
import { getEnvMark } from "../runtime/common-methods/utils";
/**
 * 加载（腾讯地图）JS API
 * 参考文档：https://lbs.qq.com/webApi/javascriptV2/jsGuide/jsBasic
 * @returns qq
 */
export function TMap() {
  return new Promise(function(resolve, reject) {
    window.init = function() {
      resolve(qq); //注意这里
    };
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `https://map.qq.com/api/js?v=2.exp&callback=init&key=${config.otherConfig.tenCentMapKey}`;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

/**
 * 加载（腾讯地图）前端定位组件
 * 参考文档：https://lbs.qq.com/webApi/component/componentGuide/componentGeolocation
 * 调用方式三
 * @returns qq.maps.Geolocation
 */
export function getGeolocation() {
  return new Promise(function(resolve, reject) {
    window.initGeolocation = function() {
      resolve(new qq.maps.Geolocation()); //注意这里
    };
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://apis.map.qq.com/tools/geolocation/min?key=3ESBZ-Q5QWI-PSKGI-5ED3F-VX32T-ZQBVI&referer=hd&callback=initGeolocation";
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

/**
 * 异步加载高德地图 JS API
 * 参考文档：https://lbs.amap.com/api/javascript-api/guide/abc/load
 * @returns AMap
 */
export function AMapLoader() {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap);
    } else {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src =
        "https://webapi.amap.com/maps?v=1.4.15&callback=initAMap&key=e363776d05cbe0a3e702b6cef53008ed";
      script.onerror = reject;
      document.head.appendChild(script);
    }
    window.initAMap = () => {
      resolve(window.AMap);
    };
  });
}

/**
 * 加载高德地图JS API --对接新key，合规整改
 * @returns AMap
 */
export function AMapLoaderNew() {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap);
    } else {
      window._AMapSecurityConfig = {
        // 测试环境代理地址:"https://apigw-beta.test.hihonor.com/api/_AMapService"
        // 生产环境代理地址：https://apigw.yun.hihonor.com/api/_AMapService
        serviceHost:
          config.env === "pro"
            ? "https://apigw.yun.hihonor.com/api/_AMapService"
            : "https://apigw-beta.test.hihonor.com/api/_AMapService"
      };
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = `https://webapi.amap.com/maps?v=2.0&callback=initAMap&key=${config.otherConfig.aMapKey}`;
      script.onerror = reject;
      document.head.appendChild(script);
      window.initAMap = () => {
        resolve(window.AMap);
      };
    }
  });
}

/**
 * 加载高德地图JS API --对接新key，获取经纬度
 * @returns geolocation
 */
export function AMapGetLocationReal() {
  return new Promise((resolve, reject) => {
    AMapLoaderNew().then(AMap => {
      AMap.plugin("AMap.Geolocation", () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 50000, //超过10秒后停止定位，默认：无穷大
          maximumAge: 0, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, //显示定位按钮，默认：true
          buttonPosition: "LB", //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          needAddress: true //是否需要将定位结果进行逆地理编码操作
        });
        geolocation.getCurrentPosition((status, result) => {
          console.log("status==", status);
          console.log("result==", result);
          if (status === "complete") {
            const obj = {
              coordinateType: CoordinateType.GCJ02,
              status: "complete",
              longitude: result.position.lng,
              latitude: result.position.lat
            };
            resolve(obj);
          } else if (status === "error") {
            // 使用默认位置: 北京市（gcj02坐标系）
            const obj = {
              coordinateType: CoordinateType.GCJ02,
              status: "error",
              longitude: "116.4074",
              latitude: "39.9042"
            };
            console.error("getCurrentPosition()获取定位信息失败", result);
            resolve(obj);
          }
        });
      });
    });
  });
}

export async function getLocationInfoByGeolocation(isHighAccuracy) {
  return new Promise(resolve => {
    // 使用默认位置: 北京市（gcj02坐标系）
    let obj = {
      coordinateType: CoordinateType.GCJ02,
      status: "error",
      longitude: "116.4074",
      latitude: "39.9042"
    };
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          if (position.coords) {
            obj = {
              coordinateType: CoordinateType.WGS84,
              status: "complete",
              longitude: position.coords.longitude,
              latitude: position.coords.latitude
            };
            resolve(obj);
          } else {
            // 使用默认位置: 北京市（gcj02坐标系）
            console.error(
              "navigator.geolocation.getCurrentPosition()获取定位信息异常",
              position
            );
            resolve(obj);
          }
        },
        error => {
          const err = error.code;
          switch (err) {
            case 1:
              console.error(
                "navigator.geolocation.getCurrentPosition()：用户拒绝了位置服务"
              );
              break;
            case 2:
              console.error(
                "navigator.geolocation.getCurrentPosition()：获取不到位置信息"
              );
              break;
            case 3:
              console.error(
                "navigator.geolocation.getCurrentPosition()：获取信息超时"
              );
          }
          resolve(obj);
        },
        {
          enableHighAccuracy: isHighAccuracy, //是否获取高精度经纬度
          timeout: 10000, //获取位置信息的超时时间
          maximumAge: 0, //获取位置信息的缓存时间。单位为毫秒（ms），默认值为0（立即更新获取）。如果设备缓存的位置信息超过指定的缓存时间，将重新更新位置信息后再返回。
          provider: "system", // 优先使用的定位模块
          coordsType: "wgs84", // 指定获取的定位数据坐标系类型
          geocode: true // 是否解析地址信息。如果解析地址信息失败则返回的Position对象的address、addresses属性值为null
        }
      );
    } else {
      console.error("navigator.geolocation找不到");
      // 使用默认位置: 北京市（gcj02坐标系）
      resolve(obj);
    }
  });
}

export function AMapGetLocation() {
  const env = getEnvMark();
  if (env === EnvMark.alipayMp && /(Android)/i.test(navigator.userAgent)) {
    // 安卓、支付宝小程序环境打开用原生定位方法
    return new Promise(async resolve => {
      const locationObj = await getLocationInfoByGeolocation(true);
      if (locationObj.status === "complete") {
        const lnglat = [locationObj.longitude, locationObj.latitude];
        AMapLoaderNew().then(AMap => {
          AMap.convertFrom(lnglat, "gps", function(status, result) {
            if (result.info === "ok") {
              const lngAndLat = result.locations[0];
              const obj = {
                coordinateType: CoordinateType.WGS84,
                status: "complete",
                longitude: lngAndLat.lng,
                latitude: lngAndLat.lat
              };
              resolve(obj);
            } else {
              const obj = {
                coordinateType: CoordinateType.GCJ02,
                status: "error",
                longitude: "116.4074",
                latitude: "39.9042"
              };
              resolve(obj);
            }
          });
        });
      } else {
        resolve(locationObj);
      }
    });
  } else {
    return new Promise(async resolve => {
      const result = await AMapGetLocationReal();
      resolve(result);
    });
  }
}



// WEBPACK FOOTER //
// ./src/page/vibrantRubikCube/runtime/TMap.js